import React, { useState } from 'react';
import { View, Image, Dimensions } from 'react-native';
import type { NativeStackScreenProps } from '@react-navigation/native-stack';
import { TRootStackParamList } from 'app/types/navigation';
import { useNavigation } from '@react-navigation/native';
import { MainLayout } from '@shared/components/md-design-system/Layout/MainLayout';
import { PdfViewer } from '@shared/components/PdfViewer';
import { Text } from '@shared/components/text';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';
import LoadingSpinner from '@shared/components/md-design-system/Layout/LoadingSpinner';

type Props = NativeStackScreenProps<TRootStackParamList, 'DocumentViewerPage'>;

const { width, height } = Dimensions.get('window');

export const DocumentViewer = (props: Props) => {
  const { fileUrl, fileType } = props.route.params;
  const { t } = dynamicTranslations();
  const navigation = useNavigation();
  const [imageLoading, setImageLoading] = useState(true);

  if (!fileUrl) {
    return (
      <View>
        <Text>{t('commons.connection.failedToConnect')}</Text>
      </View>
    );
  }

  const isImage = fileType.startsWith('image/');

  return (
    <MainLayout navigation={() => navigation.goBack()}>
      {isImage ? (
        <View className="flex-1 bg-white justify-center items-center">
          {imageLoading && (
            <View className="absolute inset-0 justify-center items-center">
              <LoadingSpinner size="medium" color="primary" />
            </View>
          )}
          <Image
            source={{ uri: fileUrl }}
            style={{ width, height: height * 0.85 }}
            resizeMode="contain"
            onLoad={() => setImageLoading(false)}
            onError={() => setImageLoading(false)}
          />
        </View>
      ) : (
        <PdfViewer
          pdfUrl={fileUrl}
          onError={() => {}}
        />
      )}
    </MainLayout>
  );
};
